import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'phoenix-action-button',
  template: `
    <div class="flex flex-row items-center">
      <div class="inline-block float-left w-[40px] ml-3">
        @if (loading) {
          <mat-spinner
            class="mr-3"
            [diameter]="25"
            aria-label="loading-spinner"
          ></mat-spinner>
        }
      </div>
      <button
        color="primary"
        matButton="filled"
        [disabled]="loading || disabled"
        (click)="onSubmit()"
        [attr.aria-label]="ariaLabel"
        [type]="type"
      >
        {{ label }}
      </button>
    </div>
  `,
  standalone: false,
})
export class ActionButtonComponent {
  @Input() loading = false;
  @Input() label = 'Save';
  @Input() ariaLabel = 'save-button';
  @Input() disabled = true;
  @Input() type = 'button';

  // Outputs
  @Output() saveSubmit = new EventEmitter();

  onSubmit() {
    this.saveSubmit.emit();
  }
}
